import { render, staticRenderFns } from "./CurrentExercise.vue?vue&type=template&id=2576f1f2&scoped=true&"
import script from "./CurrentExercise.vue?vue&type=script&lang=js&"
export * from "./CurrentExercise.vue?vue&type=script&lang=js&"
import style0 from "./CurrentExercise.vue?vue&type=style&index=0&id=2576f1f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576f1f2",
  null
  
)

export default component.exports